export function getWebLinkFrom({ deeplink }: { deeplink: string }) {
  if (!isSimpleBrowserDeepLink(deeplink)) {
    return deeplink;
  }

  try {
    return getWebsiteUrlFromSearchParams(deeplink);
  } catch (error) {
    return replaceDeeplinkPrefix(deeplink);
  }
}

function getWebsiteUrlFromSearchParams(deeplink: string) {
  const url = new URL(deeplink);
  const destinationLink = url.searchParams.get('url');

  if (!destinationLink) {
    throw new Error('no url search params');
  }

  return getWebsiteUrlFrom({ embedWebUrl: destinationLink });
}

function replaceDeeplinkPrefix(deeplink: string) {
  const deepLinkWithoutPrefix = deeplink
    // eslint-disable-next-line eslint-rules/no-invalid-zigzag-uri-scheme
    .replace('zigzag:///simple_browser?url=', '')
    .replace('zigzag://open/simple_browser?url=', '');

  const deepLinkWithURIDecodedAssert = isEncodedUrl(deepLinkWithoutPrefix)
    ? decodeURIComponent(deepLinkWithoutPrefix)
    : deepLinkWithoutPrefix;

  return getWebsiteUrlFrom({ embedWebUrl: deepLinkWithURIDecodedAssert });
}

function isSimpleBrowserDeepLink(deeplink: string) {
  return (
    deeplink
      // eslint-disable-next-line eslint-rules/no-invalid-zigzag-uri-scheme
      .replace('zigzag:///simple_browser', 'zigzag://open/simple_browser')
      .startsWith('zigzag://open/simple_browser')
  );
}

function isEncodedUrl(url: string) {
  const isEncodedHttps = url.startsWith(encodeURIComponent('https://'));
  const isEncodedHttp = url.startsWith(encodeURIComponent('http://'));

  return isEncodedHttps || isEncodedHttp;
}

function getWebsiteUrlFrom({ embedWebUrl }: { embedWebUrl: string }) {
  const webUrl = embedWebUrl
    .replace('https://store.zigzag.kr', 'https://zigzag.kr')
    .replace('https://store.beta.zigzag.kr', 'https://beta.zigzag.kr')
    .replace('https://store.alpha.zigzag.kr', 'https://alpha.zigzag.kr');

  return webUrl;
}
